import { render, staticRenderFns } from "./AddNewLocation.vue?vue&type=template&id=85a45fa8&"
import script from "./AddNewLocation.vue?vue&type=script&lang=js&"
export * from "./AddNewLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports